<template>
  <div class="gold-view net-value" :class="isCjehApp() ? 'cjeh-app' : ''">
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>净值报送</h1>
      </div>
    </div>
    <div class="view-scroller has-header has-footer">
      <div class="reminder" v-show="tipShow">
        {{ firstTip }}<br />{{ secondTip }}
      </div>
      <div class="upload-box" v-for="(item, index) in proList" :key="index">
        <div class="upload upload-top">
          <div v-show="!item.showUploadExc">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <!-- accept=".xlsx,.xls" -->
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                @change="uploadFile($event, index, item)"
                type="file"
                id="file"
                :ref="'excFile' + index"
                name="excFile"
              />
            </a>
            <p>
              (Excel文件，填写示例见模板内容)
              <a :href="`${downUrl}` + '/cjscweb/web/goldCJ/jzbs.xls'">
                <button class="down-load">模板下载</button>
              </a>
            </p>
          </div>
          <div v-show="item.showUploadExc" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span>
                  {{ item.excName }}
                </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div class="delete-img" @click="deleteExc(index)">
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload upload-top">
          <div v-show="!item.showUploadImg">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <!-- accept=".pdf,.png,.jpg" -->
              <input
                accept="application/pdf,image/png,image/jpg"
                @change="
                  uploadImg(
                    $event,
                    index,
                    item.uploadIndex,
                    item.prod_record_num
                  )
                "
                type="file"
                id="file"
                :ref="'file' + index"
                name="imgFile"
              />
            </a>
            <p>(盖章扫描件，格式为PDF或图片)</p>
          </div>
          <div v-show="item.showUploadImg" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span>
                  {{ item.imgName }}
                </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div
                class="delete-img"
                @click="deleteImg(index, item.prod_record_num)"
              >
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload list">
          <div class="item">
            <div class="list-label">产品名称</div>
            <div class="right-input spec-name">
              <div class="cell">
                <p>
                  {{ item.prod_name }}
                </p>
                <!-- <input
                  type="text"
                  v-model="item.prod_name"
                  readonly
                  class="font-title-color right-span input-name"
                  maxlength="100"
                  placeholder="请填写"
                /> -->
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">备案编码</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_record_num"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">产品策略</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_strategy"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">联系人</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_manager_name"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-time">
          <div class="tab-top">
            <div
              class="time"
              v-for="(list, dateIndex) in item.preWeekDate"
              :key="dateIndex"
              :class="item.listIndex === dateIndex ? 'active' : ''"
              @click="changeTime(dateIndex, index)"
            >
              <p>{{ list.week | weekFilter }}</p>
              <p>{{ list.init_date | dateFilter }}</p>
            </div>
          </div>
          <div
            class="tab-content"
            v-for="(list, dateIndex) in item.preWeekDate"
            :key="dateIndex"
            v-show="item.listIndex === dateIndex ? true : false"
          >
            <div class="item">
              <div class="list-label">资产净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    maxlength="100"
                    v-model="list.asset_nav"
                    class="font-title-color right-span"
                    placeholder="请填写"
                    @input="
                      list.asset_nav = list.asset_nav.replace(/[^\d\.]/g, '')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">资产份额</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.asset_quota"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.asset_quota = list.asset_quota.replace(
                        /[^\d\.]/g,
                        ''
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">单位净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.unit_nav"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.unit_nav = list.unit_nav.replace(/[^\d\.]/g, '')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">累计净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.accumulate_nav"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.accumulate_nav = list.accumulate_nav.replace(
                        /[^\d\.]/g,
                        ''
                      )
                    "
                  />
                  <!-- @blur="
                      list.accumulate_nav = list.accumulate_nav.replace(
                        /[^\d\.]/g,
                        ''
                      )
                    " -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="add-more">+点击添加报送</div> -->
      <div class="tips">
        <p>温馨提醒:</p>
        <p>
          1.非长江证券提供经纪服务或基金运营服务的参赛私募管理人，须在每周前两个交易日内，提供截至上周最后一个交易日的净值数据，并提供由私募基金托管人或外包服务机构盖章的净值文件。若产品未能按要求在规定时间内提供上述数据，则不纳入该时段评选;两次未在规定时间内提供数据视为自动退赛，连续60个交易日净值无变动，则不参与全赛李评选;
        </p>
        <p>
          2.长江证券有权要求参赛私募基金管理人提供私募基金的估值表等信息以证实产品净值的真实性。如参赛者提供的估值表不准确，长江证券有权取消其参赛资格;
        </p>
        <p>
          3.通过本次大赛参赛页面进行报送，如报送数据异常发送邮件至:jcjds@c-jsc.com
        </p>
      </div>
    </div>
    <div class="footer" @click="submitList()">提交</div>
    <mt-popup
      v-model="showPopup"
      class="sign-up-popup"
      popup-transition="popup-fade"
      :close-on-click-modal="false"
    >
      <div class="common-popup-box">
        <i class="close-popup-icon" @click="showPopup = false"></i>
        <h3 class="popup-title" v-show="isSuccess">提交成功</h3>
        <h3 class="popup-title" v-show="!isSuccess">提交失败</h3>
        <div class="popup-contend">
          <p v-show="!isSuccess">{{ errorMsg }}</p>
          <div class="img success-img" v-show="isSuccess">
            <img src="../assets/success-img.png" alt />
          </div>
          <div class="img failure-img" v-show="!isSuccess">
            <img src="../assets/failure-img.png" alt />
          </div>
          <div class="confirm-btn" @click="closeTips()">确认</div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import cache from '../proxy/cache.js'
import nativeService from '../services/common/nativeService.js'
import dateService from '../services/common/dateService.js'
import cjServices from '../services/cjServices.js'
// import { servers } from '../services/cjServices.js'
import { Toast } from 'mint-ui'
export default {
  filters: {
    weekFilter(value){
      switch (value) {
        case '1':
          return '周一';
        case '2':
          return '周二';
        case '3':
        return '周三';
        case '4':
        return '周四';
        case '5':
        return '周五';
      }
    },
    dateFilter(value) {
      value = dateService.format(new Date(value),'MM/DD')
      return value
    }
  },
  data() {
    return {
      // servers,
      timeObj: {
        asset_nav : '资产净值', 
        asset_quota : '资产份额', 
        unit_nav : '单位净值',
        accumulate_nav : '累计净值'
      },
      // 是否展示提交成功、失败提示弹窗
      showPopup: false,
      isSuccess: false,
      errorMsg: '',
      proList: [],
       // 提醒是否显示
      tipShow: false,
      firstTip: '',
      secondTip: '',
      // tip: firstTip + ' </br>'+ secondTip,
      // 下载地址
      downUrl:nativeService.isProduction() ? 'https://u.95579.com' : 'https://regard01.95579.com'

    }
  },
  methods:{
    dateFormat(date,format = this.$date.MD){
      // 先转换为时间戳
      date = (new Date(date)).getTime()
      return this.$date.format(date, format)
      
    },
    // 去空
    trimObj(arr) {
      for (var i in arr) {
        arr[i] = typeof arr[i] == 'string' ? arr[i].trim() : arr[i]
        if (i === 'preWeekDate'&& arr['preWeekDate']){
          for( let j = 0; j <= arr['preWeekDate'].length-1; j++){
          this.trimObj(arr['preWeekDate'][j])
          }
        }
      }
      return arr
    },
    vialist(arr) {
      // arr = this.trimObj(arr)
      // asset_nav asset_quota unit_nav accumulate_nav
      for(let i = 0; i < arr.length; i++) { 
        for(var j in arr[i]) {
          delete arr[i].tip
          if(arr[i][j] === '') { 
            return i
          } else if (j==='preWeekDate'&& arr[i]['preWeekDate'].length!==0) {
            for(let k = 0; k < arr[i]['preWeekDate'].length; k++){
              for(var h in arr[i]['preWeekDate'][k]){
                arr[i]['preWeekDate'][k][h] = typeof arr[i]['preWeekDate'][k][h] == 'string' ? arr[i]['preWeekDate'][k][h].trim() : arr[i]['preWeekDate'][k][h]
                if(Object.keys(this.timeObj).includes(h)) {
                  if(arr[i]['preWeekDate'][k][h] === ''){
                    return [i,k,h]
                  }
                }
              }
            }
          }
        }
      }
    },
    submitList() {
      // 避免数据为空 点击提交成功
      if (this.proList && this.proList.length === 0 ) {
       Toast({
            message: '暂无数据，无法提交',
            duration: 1000
        })
        return false
      }
      const i = this.vialist(this.proList)
      if(i instanceof Array){
        Toast({
            message: `请输入第${i[0]+1}条净值报送中的第${i[1]+1}个${this.timeObj[i[2]]}！`,
            duration: 3000
        })
        return 
      }else{
        if (i||i == 0) {
          Toast({
            message: `请填写完整第${i+1}个净值报送数据`,
            duration: 3000
          })
          return
        }
      }
      const obj = this.proList.map(l => {
        return {
          i_prod_record_num:l.prod_record_num,
          goldCJToken:cache.getLocalCache('goldCJToken'),
          i_nav_str: this.connectTimeData(l.preWeekDate)
        }
      })
      const arr1 = []
      for (let i = 0; i < obj.length; i++) {
        const a = this.handleSubmit(obj[i])
        arr1.push(a)
      } 
      Promise.all(arr1).then( res => {
        const data = res.filter((l) => {
          return l.error_code !== '0'
        })
        if (data.length > 0){
          this.showPopup = true
          this.isSuccess = false
          this.errorMsg = '提示:' + data[0].error_info
          }else {
            this.showPopup = true
            this.isSuccess = true

        }
      },(error) => {
        console.log(error,'error');
      })
    }, 
    // 拼接数据
    connectTimeData(timeArr) {
      let str = ''
      for (let i = 0; i < timeArr.length; i++) {
        let item = timeArr[i]
        if (timeArr.length >= 2 && i < timeArr.length - 1){
          str += item.asset_nav + ';' + item.asset_quota + ';' + item.unit_nav + ';' + item.accumulate_nav + ';' + item.init_date +'@@'

        } else {
          str += item.asset_nav + ';' + item.asset_quota + ';' + item.unit_nav + ';' + item.accumulate_nav + ';' + item.init_date
        }
      }
      return str
    },
     //点击时间切换
    changeTime(sonIndex,index) {
      this.proList[index].listIndex = sonIndex
    }, 
    // 上传文件
    uploadFile(e,index,item) {
      const arr = []
      for( let i =0; i< item.preWeekDate.length; i++){
        arr.push(item.preWeekDate[i].init_date + '_' + item.preWeekDate[i].week)
      }
      console.log(arr.join(','));
      const fileName = e.target.files[0]
       let form = new FormData(); // FormData 对象
      form.append("excelFile", fileName)
      form.append("goldCJToken", cache.getLocalCache('goldCJToken'))
      form.append("prod_record_num", item.prod_record_num)
      form.append("init_dates", arr.join(','))
      cjServices.uploadExc(this,form).then(res => {
        if (res.body && res.body.error_code == '0') {
          if (res.body.results && res.body.results.length !== 0) {
            this.proList[index].excName =  e.target.files[0].name
            e.target.value = ''
            // this.$refs.['excFile' + index].value = ''
            this.proList[index].showUploadExc = true
            const arr1 = JSON.parse(JSON.stringify(res.body.results))
            let arr2 =JSON.parse(JSON.stringify(this.proList[index].preWeekDate)) 
            for(let i =0; i< arr1.length; i++){
              for(let j =0; j< arr2.length; j++) {
                if (arr1[i].init_date === arr2[j].init_date){
                  arr2[j] = arr1[i]
                } 
            }
            }
            this.proList[index].preWeekDate = arr2
          } 
          else {
            Toast({
              message: '请在excel中包括上周您所选产品对应的净值信息',
              duration: 3000
            })
          }
        } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
          cache.clearLocalCache('goldCJToken')
          this.$router.push('/index')
         } else {
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
        }
      })
    },  
    // 上传pdf
    uploadImg(e,index,uploadIndex,prod_record_num) {
      console.log(index,uploadIndex);
      if(index === uploadIndex){
        const fileName = e.target.files[0]
         let form = new FormData(); // FormData 对象
        form.append("pdfFile", fileName)
        form.append("goldCJToken", cache.getLocalCache('goldCJToken'))
        form.append("i_prod_record_num", prod_record_num)
         cjServices.uploadPdf(this,form).then(res => {
          if (res.body && res.body.error_code == '0') {
            this.proList[index].imgName =  e.target.files[0].name
            // 解决不同input上传一样的文件上传不了的问题
            e.target.value = ''
            // this.$refs['file' + index].value = ''
            this.proList[index].showUploadImg = true
          }else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
          cache.clearLocalCache('goldCJToken')
          this.$router.push('/index')
         } else {
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
         }
        })
      }
    },
    // 删除exc 
    deleteExc(index) {
      this.proList[index].showUploadExc = false
      const arr = JSON.parse(JSON.stringify(this.proList[index].preWeekDate))
      this.proList[index].preWeekDate = arr.map(l=>{
        return {
          ...l,
          asset_nav: '',
          asset_quota: '',
          unit_nav: '',
          accumulate_nav: '',
        }
      })
    },
    // 删除pdf
    deleteImg(index,prod_record_num) {
      this.proList[index].showUploadImg = false
      cjServices.deletePdf(this,{goldCJToken: cache.getLocalCache('goldCJToken'),i_prod_record_num: prod_record_num}).then(res => {
        if (res.body && res.body.error_code == '0') {
          Toast({
              message: res.body.error_info,
              duration: 2000
          });
        } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
          cache.clearLocalCache('goldCJToken')
          this.$router.push('/index')
         }  else {
           Toast({
              message: res.body.error_info,
              duration: 2000
            })
        }
      })
    },
    // 获取整个列表数据
    getProList() {
      cjServices.getDataList(this,{goldCJToken:cache.getLocalCache('goldCJToken') }).then(res => {
         if (res.body && res.body.error_code == '0') {
           this.proList = res.body.results.map((l,index) => {
             return {
               ...l,
              listIndex:0,
              uploadIndex:index,
              //图片是否上传
              showUploadImg:false,
              showUploadExc:false,
            }
          })
          if (res.body.results && res.body.results[0] && res.body.results[0].tip) {
            this.firstTip = res.body.results[0].tip

          }
          if (res.body.results && res.body.results[0] && res.body.results[0].preWeekDate && res.body.results[0].preWeekDate[0].tip !== '') {
            this.secondTip = res.body.results[0].preWeekDate[0].tip
          }
          if (this.firstTip !== '' || this.secondTip != '') {
            this.tipShow = true
          }
          console.log(this.proList,'列表数据')
         } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
          cache.clearLocalCache('goldCJToken')
           nativeService.routerRedirect('/index', this)

         } else {
            Toast({
                message: res.body.error_info,
                duration: 2000
            })
        }
      })
    }, 
    // 提交接口封装
    handleSubmit(obj) {
      return new Promise((resolve) => {
        cjServices.netValueSubmit(this,obj).then(res => {
          if (res.body.error_code === '-9999'){
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
            cache.clearLocalCache('goldCJToken')
            nativeService.routerRedirect('/login', this)
          } else if (res.body && res.body.error_code !== '-9999') {
            resolve({'error_code':res.body.error_code,'error_info':res.body.error_info})
          }
        })
      })
    },
    // 关闭提示
    closeTips() {
      this.showPopup = false
    },
    goBack() {
      nativeService.routerRedirect(-1, this)
    },
    isCjehApp() {
      if (navigator.userAgent.indexOf('cjsccjeh') > -1) {
        return true
      } else {
        return false
      }

    }
  },
  created () {
    this.getProList()
  }
}
</script>


<style lang="scss" scoped>
@import "sass/gold/common.scss";
@import "sass/gold/submission.scss";
</style>